
import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../../../components/base/Card';
import { Button } from '../../../components/base/Button';
import { upcomingEvents } from '../../../mocks/events';

export const UpcomingEvents: React.FC = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Upcoming Events</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Join us for these exciting cultural events and educational programs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {upcomingEvents.slice(0, 6).map((event) => (
            <Card key={event.id} hover className="overflow-hidden">
              <img
                src={event.image}
                alt={event.title}
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="bg-red-100 text-red-800 text-xs font-medium px-2 py-1 rounded-full">
                    {event.category}
                  </span>
                  <span className="text-red-600 font-semibold text-sm">
                    {event.price}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {event.title}
                </h3>
                <div className="space-y-2 mb-4">
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="ri-calendar-line text-red-600 mr-2"></i>
                    <span>{event.date}</span>
                  </div>
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="ri-time-line text-red-600 mr-2"></i>
                    <span>{event.time}</span>
                  </div>
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="ri-map-pin-line text-red-600 mr-2"></i>
                    <span>{event.location}</span>
                  </div>
                </div>
                <p className="text-gray-700 text-sm mb-4 line-clamp-3">
                  {event.description}
                </p>
                <Button size="sm" className="w-full">
                  Learn More
                </Button>
              </div>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Link to="/events">
            <Button variant="outline" size="lg">
              View All Events
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
